import React, { Component } from 'react';

import Projects from './Projects';
import Social from './Socials';
import Title from './title';
import Jokes from './jokes'

class App extends Component {
        
    render(){
        return(
            <div>
                <div align="center" className="jumbotron">
                    <h1>Hey!</h1>
                    <p>You have reached N Krithick Santhosh</p>
                    <Title />
                    <p><Social/></p>
                </div>

                <br/>

                <Projects/>

                <div align="center" className="jumbotron" style={{height:"180px",marginBottom:"0px",marginTop:"100px"}}>
                    <p>Am looking for opportunities in collaborative and challenging environments. Click here for my Resume.</p>
                    <p><Social/></p>
                    <Jokes/>
                </div>

            </div>
        );
    }
}

export default App;